import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const translations = {
  ka: {
    backToHome: "მთავარ გვერდზე დაბრუნება",
    pageTitle: "თხილის დამუშავების აღწერილობა",
    description: "სპეციალურად შექმნილი მანქანები თხილის დახარისხებისთვის, გაწმენდისა და დამუშავებისთვის",
    detailedInfo: "ჩვენ ვაწარმოებთ მაღალი ხარისხის თხილის დამუშავების აღჭურვილობას, რომელიც განკუთვნილია საქართველოს თხილის მწარმოებლებისთვის. ჩვენი აღჭურვილობა მოიცავს დახარისხების, გაწმენდისა და დამუშავების სრული ციკლის მანქანებს.",
    features: "ძირითადი მახასიათებლები",
    feature1: "ავტომატური დახარისხება ზომის მიხედვით",
    feature2: "გაწმენდისა და გარეცხვის სისტემები",
    feature3: "მაღალი წარმადობა",
    feature4: "გრძელვადიანი კონსტრუქცია",
    feature5: "მარტივი მართვა და მოვლა",
    feature6: "ინდივიდუალური მორგება"
  },
  en: {
    backToHome: "Back to Home",
    pageTitle: "Hazelnut Processing Equipment",
    description: "Custom-built machinery for sorting, cleaning, and processing hazelnuts",
    detailedInfo: "We manufacture high-quality hazelnut processing equipment designed for Georgian hazelnut producers. Our equipment includes complete cycle machines for sorting, cleaning, and processing.",
    features: "Key Features",
    feature1: "Automatic sorting by size",
    feature2: "Cleaning and washing systems",
    feature3: "High productivity",
    feature4: "Long-lasting construction",
    feature5: "Easy operation and maintenance",
    feature6: "Custom adaptation"
  },
  ru: {
    backToHome: "Вернуться на главную",
    pageTitle: "Оборудование для переработки фундука",
    description: "Специально созданные машины для сортировки, очистки и переработки фундука",
    detailedInfo: "Мы производим высококачественное оборудование для переработки фундука, предназначенное для грузинских производителей фундука. Наше оборудование включает в себя машины полного цикла для сортировки, очистки и переработки.",
    features: "Основные характеристики",
    feature1: "Автоматическая сортировка по размеру",
    feature2: "Системы очистки и мойки",
    feature3: "Высокая производительность",
    feature4: "Долговечная конструкция",
    feature5: "Простая эксплуатация и обслуживание",
    feature6: "Индивидуальная адаптация"
  }
};

export default function ServiceHazelnutProcessing({ language = 'ka' }) {
  const navigate = useNavigate();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center space-x-2 text-slate-700 hover:text-orange-500 mb-8 transition"
        >
          <ArrowLeft size={20} />
          <span>{t.backToHome}</span>
        </button>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=1200"
            alt={t.pageTitle}
            className="w-full h-96 object-cover"
          />
          
          <div className="p-8">
            <h1 className="text-4xl font-bold text-slate-800 mb-4">{t.pageTitle}</h1>
            <p className="text-xl text-slate-600 mb-8">{t.description}</p>
            
            <p className="text-slate-700 mb-8 leading-relaxed">{t.detailedInfo}</p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">{t.features}</h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature1}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature2}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature3}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature4}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature5}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature6}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
